import { render, staticRenderFns } from "./PriceListEditor.vue?vue&type=template&id=45b36ab6&scoped=true"
import script from "./PriceListEditor.vue?vue&type=script&lang=js"
export * from "./PriceListEditor.vue?vue&type=script&lang=js"
import style0 from "./PriceListEditor.vue?vue&type=style&index=0&id=45b36ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b36ab6",
  null
  
)

export default component.exports